<template>
  <div class="subtitle">
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="reds"
        @change="onChangeReds($event)"
      />
      <span class="red"></span> Parcialmente
      <span
        v-b-tooltip.hover
        title="Pessoas faltando a realização de 1 ou mais da(s) boa(s) prática(s) recomendada(s) no indicador."
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="greens"
        @change="onChangeGreens($event)"
      />
      <span class="green"></span> Totalmente
      <span
        v-b-tooltip.hover
        title="Pessoas com a(s) boa(s) prática(s) recomendada(s) no indicador."
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    setRed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      reds: false,
      greens: false,
    }
  },
  watch: {
    setRed: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          // this.$emit('resetarNome', this.setRed)
          this.greens = false
          this.reds = true
        }
      },
      deep: true,
    },
  },
  methods: {
    onChangeReds(event) {
      this.greens = false
      this.$emit('exibirVermelhos', event.target.checked)
    },
    onChangeGreens(event) {
      this.reds = false
      this.$emit('exibirVerdes', event.target.checked)
    },
  },
}
</script>

<style scoped>
.subtitle-item .red {
  border: 1px solid rgb(235 64 52 / 30%);
  box-shadow: 0 5px 1px 0 rgb(235 64 52 / 80%),
    0 12px 90px 0 rgb(235 64 52 / 1%);
  margin-top: -10px;
  width: 25px;
  border-radius: 15px;
}
.subtitle-item .green {
  border: 1px solid rgb(0 128 0 / 30%);
  box-shadow: 0 5px 1px 0 rgb(0 128 0 / 80%), 0 12px 90px 0 rgb(0 128 0 / 1%);
  margin-top: -10px;
  width: 25px;
  border-radius: 15px;
}
.subtitle-item .orange {
  border: 1px solid rgba(255, 165, 0, 0.3);
  box-shadow: 0 5px 1px 0 rgba(255, 165, 0, 0.8),
    0 12px 90px 0 rgba(255, 165, 0, 0.01);
  margin-top: -10px;
  width: 25px;
  border-radius: 15px;
}
</style>
